module.exports = __webpack_public_path__ + "media/images/home-daddiolong-5d10eee2346bc08c15bd5e9cb5b20b56.jpg";